import { useContext, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthSessionContext } from '../api/AuthSession';
import axios from '../api/axios-configure';
import { StatementContext } from '../utils/context/StatementsContext';
import UserPool from 'utils/UserPool'
import { toast } from 'react-toastify';


const INACTIVITY_TIME_KEY = 'inactivityTime'
const MIN_BOUNDARY = 240
const MAX_RETRIES = 5

export function useAxiosNavigation() {
  const navRef = useRef(useNavigate());

  const { setUserName } = useContext(AuthSessionContext)
  const { cleanStore } = useContext(StatementContext)
  const navigate = useNavigate()

  useEffect(() => {
    const responseInterceptor = axios.interceptors.response.use((response) => {
      return response
    }, (error) => {
      if (error?.response?.status === 401) {
        let retries = 0
        const user = UserPool.getCurrentUser()
          user.getSession((err, session) => {
            user.refreshSession(session.getRefreshToken(), (err, result) => {
              if (err) {
                  localStorage.removeItem(INACTIVITY_TIME_KEY)
                  localStorage.setItem('jwtToken', "")
                  setUserName("")
                  localStorage.setItem('isTimeout', true)
                  toast.dismiss()
                  navigate({ pathname: '/signin' }, { replace: true })
                  user.signOut()
                  return Promise.reject(error);
              } else {
                  localStorage.setItem('jwtToken', result.accessToken.jwtToken)
                  retries += 1;
                  localStorage.setItem('isTimeout', false)
                  if (retries >= MAX_RETRIES)
                  {
                    localStorage.removeItem(INACTIVITY_TIME_KEY)
                    localStorage.setItem('jwtToken', "")
                    setUserName("")
                    localStorage.setItem('isTimeout', true)
                    return Promise.reject(error);
                  }
                  return axios(error.config);
              }
          });
        }) 
      }
      return Promise.reject(error);
    })

    const requestInterceptor = axios.interceptors.request.use((config) => {
      const inactivityTime = localStorage.getItem(INACTIVITY_TIME_KEY)
      const isInactivityInvalid = Math.round((new Date() - new Date(inactivityTime)) / 60000) >= MIN_BOUNDARY
      const token = localStorage.getItem('jwtToken')

      if (config.url === '/CreateNewUserAccount' || config.url === '/ValidateUserEmail') {
        return config;
      }

      if (!token && !inactivityTime) {
        navigate({ pathname: '/signin' }, { replace: true })
        return Promise.resolve('Request cancelled due to inactivity.');
      }

      if (inactivityTime && isInactivityInvalid) {
        cleanStore()
        localStorage.removeItem(INACTIVITY_TIME_KEY)
        localStorage.setItem('jwtToken', "")
        setUserName("")
        toast.dismiss()
        localStorage.setItem('isTimeout', true)
        navigate({ pathname: '/signin' }, { replace: true })
        return Promise.reject('Request cancelled due to inactivity.');
      }

      localStorage.setItem(INACTIVITY_TIME_KEY, new Date());

      if (token) {
          config.headers['Authorization'] = `Bearer ${token}`
      }

      const organizationId = localStorage.getItem('OrganizationId')
      if (organizationId) {
        config.headers['X-Organization-Number'] = organizationId
      }

      const user = UserPool.getCurrentUser()
      if (!user) {
        localStorage.setItem('jwtToken', "")
        setUserName("")
        localStorage.removeItem(INACTIVITY_TIME_KEY)
        localStorage.setItem('isTimeout', false)
        navigate({ pathname: '/signin' }, { replace: true })
        return Promise.reject('Request cancelled due to session.');
      }

      return config;

    })

    return () => {
      axios.interceptors.response.eject(responseInterceptor);
      axios.interceptors.request.eject(requestInterceptor)
    };
  }, []);
}

export default function AxiosNavigation() {
  useAxiosNavigation();
  return <></>;
}